import { PlatformCodeEnum } from "@repo/graphql/gql/graphql";

export const platformLabel = (code: PlatformCodeEnum | null | undefined) => {
  if (code === PlatformCodeEnum.Instagram) return "Instagram";
  if (code === PlatformCodeEnum.TikTok) return "TikTok";
  if (code === PlatformCodeEnum.MercadoLibre) return "Mercado Libre";
  return "—";
};

export const platformShortLabel = (
  code: PlatformCodeEnum | null | undefined,
) => {
  if (code === PlatformCodeEnum.Instagram) return "IG";
  if (code === PlatformCodeEnum.TikTok) return "TT";
  return "—";
};

export const formatDateShort = (raw: string | null | undefined) => {
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("es-CL", {
    day: "2-digit",
    month: "short",
  }).format(date);
};

export const formatDateLong = (raw: string | null | undefined) => {
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("es-CL", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

export const formatRangeWindow = (
  start: string | null | undefined,
  end: string | null | undefined,
) => {
  const fmt = (raw: string | null | undefined) => {
    if (!raw) return null;
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return null;
    return new Intl.DateTimeFormat("es-CL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };
  return `${fmt(start) ?? "—"} – ${fmt(end) ?? "En curso"}`;
};

export type Aggregates = {
  views: number;
  reach: number;
  likes: number;
  comments: number;
  shares: number;
  saves: number;
  interactions: number;
};

export const ZERO_AGG: Aggregates = {
  views: 0,
  reach: 0,
  likes: 0,
  comments: 0,
  shares: 0,
  saves: 0,
  interactions: 0,
};

export const sumAggregates = <T extends Partial<Aggregates>>(
  items: T[],
): Aggregates =>
  items.reduce<Aggregates>(
    (acc, item) => ({
      views: acc.views + (item.views ?? 0),
      reach: acc.reach + (item.reach ?? 0),
      likes: acc.likes + (item.likes ?? 0),
      comments: acc.comments + (item.comments ?? 0),
      shares: acc.shares + (item.shares ?? 0),
      saves: acc.saves + (item.saves ?? 0),
      interactions: acc.interactions + (item.interactions ?? 0),
    }),
    { ...ZERO_AGG },
  );
